import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Pane, Button, MenuSection, } from "@folio/stripes/components";
import { useIntl, FormattedMessage } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { useOnixCodetablesFilters } from "../../hooks/useOnixCodetablesFilters";
import { useOnixCodetablesData } from "../../hooks/useOnixCodetablesData";
import { useOnixCodetablesTable } from "../../hooks/useOnixCodetablesTable";
import { OnixCodetablesFilters } from "../../components/OnixCodetablesFilters";
import { usePageSize } from "../../hooks/usePageSize";
var OnixCodetablesList = function () {
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    var filtersHook = useOnixCodetablesFilters();
    var _b = usePageSize(), pageSize = _b.pageSize, createPageSizeHandler = _b.createPageSizeHandler;
    var dataHook = useOnixCodetablesData(filtersHook.filters, pageSize);
    var columns = useOnixCodetablesTable().columns;
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (p) { return !p; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleApplyFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var source = createStripesSource({
        ky: ky,
        data: dataHook.items,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading,
        isError: dataHook.isError,
        isLoaded: dataHook.isFetched,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
    });
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-agency.pane.title.navigation",
            }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                React.createElement(OnixCodetablesFilters, { temporaryNumberFilter: filtersHook.temporaryNumberFilter, temporaryNameFilter: filtersHook.temporaryNameFilter, onNumberFilterChange: filtersHook.setTemporaryNumberFilter, onNameFilterChange: filtersHook.setTemporaryNameFilter, onApplyFilters: handleApplyFilters })))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.onix-codetables.table.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }), actionMenu: function (_a) {
                var onToggle = _a.onToggle;
                return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            onToggle();
                            history.push("/bragency/onix-codetables/create");
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
            } },
            React.createElement(TableComponent, { data: dataHook.items, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source }))));
};
export default OnixCodetablesList;
